import { faArchive, faBookOpen, faCopy, faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from '@mui/material';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { WarningIconWithTooltip } from '../../../common-client2/src/components';
import Tooltip from '../../../common/components/UI/ToolTip/ToolTip';
import { isEdge, isIE } from '../../../common/utilities/browserDetection';
import { getRequestTypeLabel } from '../../Enums/Helpers/LabellingHelper';
import React from 'react';

import {
	Buttons, ItemTitle, RowItem,
} from './tableRow.service';

import './tableRow.scss';

class SettingRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showButtons: false
		};
	}

	showButtonsHandler = (state) => {
		this.setState({ showButtons: state })
	}

	dotsContainer = () => {
		return <div></div>
	}

	buttonsHandler = (e, action) => {
		e.stopPropagation();
		this.props.showRightPanel(action, this.props.item)
	}

	buttonsContainer = () => {
		const { t, item, isArchive = false } = this.props;
		const { isDeletable } = item;

		return (
			<Buttons>
				{isArchive
					? (
						<Button
							className="tr-buttons-action"
							onClick={(e) => { this.buttonsHandler(e, t('settings.view')) }}>
							<FontAwesomeIcon
								className="tr-font-awesome-icon"
								icon={faBookOpen} />
							{t('settings.view')}
						</Button>
					)
					: (
						<Button
							className="tr-buttons-action"
							onClick={(e) => { this.buttonsHandler(e, t('settings.edit')) }}>
							<FontAwesomeIcon
								className="tr-font-awesome-icon"
								icon={faPen} />
							{t('settings.edit')}
						</Button>
					)}
				<Button
					className="tr-buttons-action"
					onClick={(e) => { this.buttonsHandler(e, t('settings.duplicate')) }}>
					<FontAwesomeIcon
						className="tr-font-awesome-icon"
						icon={faCopy} />
					{t('settings.duplicate')}
				</Button>
				{!isArchive && (
					<>
						{isDeletable && <Button
							className="tr-buttons-action"
							onClick={(e) => { this.buttonsHandler(e, t('settings.delete')) }}>
							<FontAwesomeIcon
								className="tr-font-awesome-icon"
								icon={faTrash} />
							{t('settings.delete')}
						</Button>}
						<Button
							className="tr-buttons-action"
							onClick={(e) => { this.buttonsHandler(e, t('settings.archive')) }}>
							<FontAwesomeIcon
								className="tr-font-awesome-icon"
								icon={faArchive} />
							{t('settings.archive')}
						</Button>
					</>
				)}
			</Buttons>)
	}

	getHyperfindLabel = (hyperfindSettings) => {
		const { hyperFindList, item, t } = this.props;
		let auxLabel = ''
		if (hyperfindSettings.length > 1) {
			auxLabel = <Tooltip
				titleText={
					item.hyperfindSettings.map(config => {
						let hyperfind = this.props.hyperFindList.find(hf => hf.value === config.hyperfindId)
						if (hyperfind)
							return <div>{hyperfind.label}</div>
						return null
					}, this)
				}
				jsx={<span>{t('form.multipleHyperfindsSelected')}</span>} />
		} else {
			auxLabel = hyperFindList.find(hyperfind => hyperfind.value === hyperfindSettings[0].hyperfindId)?.label
		}

		return auxLabel ? auxLabel : hyperfindSettings[0].hyperfindId

	}

	render() {
		const { item, index, t, isArchive = false } = this.props;
		const buttonsSection = !this.state.showButtons ? this.dotsContainer() : this.buttonsContainer();
		const description = (item.description.length > 30) ? item.description.substring(0, 27) + "..." : item.description;

		const warnings = [
			...new Set(
			  item?.hyperfindSettings?.flatMap(x =>
				x.warnings?.map(x => t(`manager.managerWarnings.${x}`))
			  )
			),
		  ];

		return (
			<RowItem
				$index={index}
				disableAnimation={isArchive}
				className="tr-quota-item"
				onMouseOver={() => { this.showButtonsHandler(true) }}
				onMouseLeave={() => { this.showButtonsHandler(false) }}>
				<ItemTitle className="tr-name">
					<div className="tr-name-font-weight">{item.name}</div>
				</ItemTitle>
				<ItemTitle className="tr-warning">
					{warnings?.length > 0 && <WarningIconWithTooltip tooltipWarnings={warnings} />}
				</ItemTitle>
				<ItemTitle className="tr-description">
					{description}
				</ItemTitle>
				<ItemTitle className="tr-request-type">
					{getRequestTypeLabel(item.type)}
				</ItemTitle>
				<ItemTitle className="tr-approval-process">
					{item.approvalProcessLabel}
				</ItemTitle>
				<ItemTitle className="tr-submission-period">
					<span className="periodWrapper">
						{item.submissionPeriodLabel}
					</span>
				</ItemTitle>
				<ItemTitle className="tr-request-period">
					<span className="periodWrapper">
						{item.requestPeriodLabel}
					</span>
				</ItemTitle>
				<ItemTitle className="tr-created-by">
					{item.createdByName || ''}
				</ItemTitle>
				<ItemTitle className="tr-hyperfind-query">
					{this.getHyperfindLabel(item.hyperfindSettings)}
				</ItemTitle>
				<ItemTitle className="tr-setup">
				<span className="setupWrapper">
					{[...new Set(item.setupLabels)].map((label, index) => (
						<span key={index}>
							{index > 0 && ' • '}{label}
						</span>
					))}
				</span>
				</ItemTitle>
				<div className={['tr-button-section', (isIE() || isEdge()) ? 'tr-adjustment' : ''].join(' ')}>
					{buttonsSection}
				</div>
			</RowItem>
		)
	}
}

export default withTranslation('employmentBillboard')(SettingRow);